import InProgress from "@/features/AboutMasters/ui/InProgress.jsx";
import {MainLayout} from "@/layouts/main/index.js";

export default function AboutMastersWidget() {
    return (
        <MainLayout>
            <InProgress />
        </MainLayout>
    )
}